import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import SharePanel from '../../components/SharePanel';
import Banner from '../../components/Banner';
import Seats from '../../components/Seats';
import Header from '../../components/Header';
import PartyList from '../../components/PartyList';
import InfoText from '../../components/InfoText';
import CallButton from '../../components/CallButton';
import { getJanpanData } from '@src/services/api';

const Layout = ({ content }) => {
    const partyName1 = '执政联盟';
    const partyName2 = '在野党';
    const [localContent, setLocalContent] = useState({});
    const [isLoad, setIsLoad] = useState(false);
    const partyDetailList = localContent?.voteList?.partyDetailList || [];
    const rulingList = partyDetailList.filter((item) => item.campName === partyName1);
    const oppositionList = partyDetailList.filter((item) => item.campName === partyName2);

    useEffect(() => {
        // setLocalContent(content);
    }, [content]);

    useEffect(() => {
        let isMounted = true;

        const fetchData = async () => {
            try {
                const res = await getJanpanData();
                const nextContent = res?.data || {};

                // console.log(nextContent, 'nextContent');
                if (isMounted && nextContent) {
                    setLocalContent({ voteList: nextContent });
                    setIsLoad(true);
                }
            } catch (error) {
                // ignore polling errors to keep UI stable
            }
        };

        fetchData();
        const timer = setInterval(fetchData, 5000);

        return () => {
            isMounted = false;
            clearInterval(timer);
        };
    }, []);

    return (
        isLoad && (
            <>
                <Header content={localContent} />
                <div className={`${styles.layout} ${window.grounds ? '' : styles.sharePage}`}>
                    <Banner content={localContent} />
                    <Seats content={localContent} />
                    <PartyList title={partyName1} variant="red" list={rulingList} />
                    <PartyList title={partyName2} variant="blue" list={oppositionList} />
                    <InfoText content={localContent} />
                    <CallButton />
                    <SharePanel content={localContent} />
                </div>
            </>
        )
    );
};

Layout.propTypes = {
    content: PropTypes.object,
};

export default errorBoundary(Layout);
